module.exports = __webpack_public_path__ + "static/media/icon-hiper.25d38a7e.png";